module.exports = __webpack_public_path__ + "static/media/travel-card.d4cb3504.svg";